import {createContext, type ReactNode, use} from 'react'

// When provided, list-view filter interactions update the consumer's draft query instead of navigating.
export type PreviewQueryContextValue = {
  currentQuery: string
  onQueryChange: (newQuery: string) => void
}

const PreviewQueryContext = createContext<PreviewQueryContextValue | null>(null)

export function PreviewQueryProvider({value, children}: {value: PreviewQueryContextValue; children: ReactNode}) {
  return <PreviewQueryContext value={value}>{children}</PreviewQueryContext>
}

export function usePreviewQueryContext() {
  return use(PreviewQueryContext)
}
